import { useEffect, useState } from "react";
import { useAppSelector } from "src/hooks/redux";
import { getChangeAndChangePercentageWithoutSign } from "src/utils/methods";
const useOptionChainSocketHook = (strike, putExch, putExchType, putScripCode, putName, callExch, callExchType, callScripCode, callName, callLTP, prevCallClose, putLTP, prevPutClose, callOI, putOI, putCheckBox, callCheckBox, prevOIPut, prevOICall, putTotalQty, callTotalQty) => {
    const [updatedData, setUpdatedData] = useState({
        PE: {
            OI: putOI,
            // LTP: putLTP,
            LAST_RATE: putLTP,
            PREV_OI: prevOIPut,
            MAX_OI: 0,
            isChecked: putCheckBox == undefined ? false : putCheckBox,
            PREVIOUS_CLOSE: prevPutClose,
            SCRIPT_CODE: putScripCode,
            NAME: putName,
            EXCH: putExch,
            EXCH_TYPE: putExchType,
            TOTAL_QTY: putTotalQty,
        },
        CE: {
            OI: callOI,
            // LTP: callLTP,
            LAST_RATE: callLTP,
            PREV_OI: prevOICall,
            MAX_OI: 0,
            isChecked: callCheckBox == undefined ? false : callCheckBox,
            PREVIOUS_CLOSE: prevCallClose,
            SCRIPT_CODE: callScripCode,
            NAME: callName,
            EXCH: callExch,
            EXCH_TYPE: callExchType,
            TOTAL_QTY: callTotalQty,
        },
        strikeRate: strike,
    });
    // console.log("Scripcode: ", PE.SCRIPT_CODE);
    // console.log("Scripcode: ", PE.SCRIPT_CODE);
    const openFeedGreeks = useAppSelector((state) => {
        if (state.openFeedWs.greeksMsg &&
            state.openFeedWs.greeksMsg.PacketIdentifier == "G" &&
            (state.openFeedWs.greeksMsg.Token == putScripCode ||
                state.openFeedWs.greeksMsg.Token == callScripCode)) {
            return state.openFeedWs.greeksMsg;
        }
        else {
            return undefined;
        }
    });
    useEffect(() => {
        if (openFeedGreeks) {
            updateOptionChainGreeks(openFeedGreeks);
        }
    }, [openFeedGreeks]);
    const updateOptionChainGreeks = (update) => {
        if (Array.isArray(update)) {
            update = update[0];
        }
        if (update) {
            const currentObj = JSON.parse(JSON.stringify(updatedData));
            // console.log("state.openFeedWs.greeksMsg : ", update);
            if (update.Token == callScripCode) {
                currentObj.CE.GREEKS_DATA = update;
            }
            else if (update.Token == putScripCode) {
                currentObj.PE.GREEKS_DATA = update;
            }
            // if (props.CE.SCRIPT_CODE == 54377) {
            //   if (currentObj.CE.GREEKS_DATA == undefined) {
            //     console.log("Greeks is undefined below please check");
            //   }
            //   console.log(currentObj.CE, "currentObj", updatedData.CE);
            // }
            setUpdatedData(currentObj);
        }
    };
    useEffect(() => {
        const currentObj = JSON.parse(JSON.stringify(updatedData));
        currentObj.PE.isChecked = putCheckBox == undefined ? false : putCheckBox;
        currentObj.CE.isChecked = callCheckBox == undefined ? false : callCheckBox;
        setUpdatedData(currentObj);
        // if (currentObj.strikeRate == 18700) {
        //   console.log(
        //     "this is a tribute updatedData: ",
        //     // updatedData.PE.SCRIPT_CODE,
        //     // updatedData.strikeRate,
        //     currentObj,
        //     Date.now()
        //   );
        // }
        // console.log("Scripcode: ", PE.SCRIPT_CODE);
    }, [putCheckBox, callCheckBox]);
    const openFeedWsMsg = useAppSelector((state) => {
        if (state.openFeedWs.message) {
            let update = state.openFeedWs.message;
            if (Array.isArray(update)) {
                update = update[0];
            }
            if (callScripCode == (update === null || update === void 0 ? void 0 : update.Token) || putScripCode == (update === null || update === void 0 ? void 0 : update.Token)) {
                // if (scripCode == 999920000 || update?.Token == 999920000)
                return update;
            }
        }
        // return state.openFeedWs.message;
        //
        return undefined;
    });
    useEffect(() => {
        if (openFeedWsMsg) {
            updateOptionChain(openFeedWsMsg);
        }
    }, [openFeedWsMsg]);
    const updateOptionChain = (update) => {
        if (Array.isArray(update)) {
            update = update[0];
        }
        if (update) {
            const currentObj = JSON.parse(JSON.stringify(updatedData));
            if (update.Token == callScripCode) {
                if (update.OpenInterest !== undefined) {
                    const oiChange = getChangeAndChangePercentageWithoutSign(update.OpenInterest, currentObj.CE.PREV_OI || 0);
                    currentObj.CE.OI = update.OpenInterest;
                    currentObj.CE.OI_CHANGE = `${oiChange}`;
                }
                else if ((update === null || update === void 0 ? void 0 : update.LastRate) !== undefined) {
                    // currentObj.CE.LTP = update.LastRate;
                    currentObj.CE.LAST_RATE = update.LastRate;
                    currentObj.CE.PREVIOUS_CLOSE = update.PClose;
                    currentObj.CE.TOTAL_QTY = update.TotalQty;
                    // currentObj.CE.BID_QTY = update.BidQty;
                    // currentObj.CE.BID_RATE = update.BidRate;
                    // currentObj.CE.OFF_RATE = update.OffRate;
                }
            }
            else if (update.Token == putScripCode) {
                if (update.OpenInterest !== undefined) {
                    const oiChange = getChangeAndChangePercentageWithoutSign(update.OpenInterest, currentObj.PE.PREV_OI || 0);
                    currentObj.PE.OI_CHANGE = `${oiChange}`;
                    currentObj.PE.OI = update.OpenInterest;
                }
                else if ((update === null || update === void 0 ? void 0 : update.LastRate) !== undefined) {
                    // currentObj.PE.LTP = update.LastRate;
                    currentObj.PE.LAST_RATE = update.LastRate;
                    currentObj.PE.PREVIOUS_CLOSE = update.PClose;
                    currentObj.PE.TOTAL_QTY = update.TotalQty;
                    // currentObj.PE.BID_QTY = update.BidQty;
                    // currentObj.PE.BID_RATE = update.BidRate;
                    // currentObj.PE.OFF_RATE = update.OffRate;
                }
            }
            // if (CE.SCRIPT_CODE == 54377) {
            //   if (currentObj.CE.GREEKS_DATA == undefined) {
            //     console.log("Greeks is undefined below please check");
            //   }
            //   console.log(currentObj.CE, "currentObj", updatedData.CE);
            // }
            // if (currentObj.strikeRate == 18700) {
            //   console.log(
            //     "this is a tribute updatedData: ",
            //     // updatedData.PE.SCRIPT_CODE,
            //     // updatedData.strikeRate,
            //     currentObj,
            //     Date.now()
            //   );
            // }
            setUpdatedData(currentObj);
        }
    };
    // useEffect(() => {
    //   if (updatedData.strikeRate == 18700) {
    //     console.log(
    //       "this is a tribute PROPS UPDATED: ",
    //       // updatedData.PE.SCRIPT_CODE,
    //       // updatedData.strikeRate,
    //       Date.now()
    //     );
    //   }
    // }, [
    //   putExch,
    //   putExchType,
    //   putScripCode,
    //   putName,
    //   callExch,
    //   callExchType,
    //   callScripCode,
    //   callName,
    //   callLTP,
    //   prevCallClose,
    //   putLTP,
    //   prevPutClose,
    //   callOI,
    //   putOI,
    //   putCheckBox,
    //   callCheckBox,
    //   prevOIPut,
    //   prevOICall,
    // ]);
    // if (CE.SCRIPT_CODE == 54377) {
    //   if (updatedData.CE.GREEKS_DATA == undefined) {
    //     console.log("Greeks is undefined below please check GD");
    //   }
    //   console.log(updatedData.CE);
    // }
    // if (updatedData.strikeRate == 18700) {
    //   console.log(
    //     "this is a tribute updatedData: ",
    //     // updatedData.PE.SCRIPT_CODE,
    //     // updatedData.strikeRate,
    //     updatedData,
    //     Date.now()
    //   );
    // }
    return updatedData;
};
export default useOptionChainSocketHook;
